import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import { deleteFormulaCard } from 'api/gql-utils/overtime/mutations';
import { parseError } from 'utils/Api';
import { AppError } from 'utils/AppError';
import { OVERTIME_FORMULA_CARDS_QUERY_KEY } from './useOvertimeFormulaCards';

type DeleteFormulaCardParams = {
  id: string;
  formulaName?: string;
};

export function useDeleteFormulaCard() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: ({ id }: DeleteFormulaCardParams) => deleteFormulaCard({ id }),
    onSuccess: (_data, { formulaName }) => {
      queryClient.invalidateQueries([OVERTIME_FORMULA_CARDS_QUERY_KEY]);
      toast.show({
        content: `${formulaName ?? 'Formula'} disabled`,
        color: 'neutral',
      });
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseError(error),
        color: 'negative',
      });
    },
  });
}
